import apiCall from "./apiCall";

export const getPosts = async (pageNumber) => {
  const response = await apiCall.get(`/api/posts?page=${pageNumber}`);
  const data = response.data;
  return data;
};
